module.exports = __webpack_public_path__ + "static/media/29ADMSPC20.852f2449.jpg";